import { render } from "./WaitingApprove.vue?vue&type=template&id=7b18deca&ts=true"
import script from "./WaitingApprove.vue?vue&type=script&lang=ts"
export * from "./WaitingApprove.vue?vue&type=script&lang=ts"

import "@/styles/login-screen.css?vue&type=style&index=0&lang=css"
import "./WaitingApprove.vue?vue&type=style&index=1&id=7b18deca&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn});
